module.exports = __webpack_public_path__ + "img/book.69814800.png";